var cilMonitor = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M472,16H40A24.028,24.028,0,0,0,16,40V376a24.028,24.028,0,0,0,24,24H240v64H160v32H352V464H272V400H472a24.028,24.028,0,0,0,24-24V40A24.028,24.028,0,0,0,472,16Zm-8,352H48V272H464Zm0-128H48V48H464Z' class='ci-primary'/><rect width='32' height='32' x='400' y='304' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilMonitor };

